// App.js
import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Certifications from './components/Certifications'
import News from './components/News'
function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Certifications />
        <News />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;